import { render, staticRenderFns } from "./infoTemplate.vue?vue&type=template&id=785ae9e8"
import script from "./infoTemplate.vue?vue&type=script&lang=js"
export * from "./infoTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports